export const numberGenerator = (type: 'negative' | 'positive' = 'positive') => {
  let counter = 0;

  return (): number => {
    counter += 1;

    return type === 'positive' ? counter : counter * -1;
  };
};
